// ** React Imports
import { useEffect } from "react";

// ** Redux & Store & Actions
import { connect } from "react-redux";
import { register } from "store/modules/auth";

// ** Third Party Components
import { Wizard } from "react-use-wizard";
import loadable from "@loadable/component";

// ** Custom Components
import Block from "components/layout/Block";

//** Register Components
import StepGender from "containers/Landing/containers/Register/components/StepGender";
const StepCoupleGender = loadable(
	() =>
		import(
			"containers/Landing/containers/Register/components/StepCoupleGender"
		),
	{ ssr: false }
);
const StepAge = loadable(
	() => import("containers/Landing/containers/Register/components/StepAge"),
	{ ssr: false }
);
const StepLogin = loadable(
	() => import("containers/Landing/containers/Register/components/StepLogin"),
	{
		ssr: false,
	}
);
const StepEmail = loadable(
	() => import("containers/Landing/containers/Register/components/StepEmail"),
	{
		ssr: false,
	}
);
const StepPassword = loadable(
	() =>
		import(
			"containers/Landing/containers/Register//components/StepPassword"
		),
	{
		ssr: false,
	}
);
const StepLocation = loadable(
	() =>
		import(
			"containers/Landing/containers/Register/components/StepLocation"
		),
	{
		ssr: false,
	}
);
const StepThankYou = loadable(
	() =>
		import(
			"containers/Landing/containers/Register/components/StepThankYou"
		),
	{
		ssr: false,
	}
);

// #####################################################

const Register = ({ coupleCase }) => {
	useEffect(() => {
		StepCoupleGender.preload();
		StepAge.preload();
		StepLogin.preload();
		StepPassword.preload();
		StepEmail.preload();
		StepLocation.preload();
		StepThankYou.preload();
	}, []);

	// #####################################################

	return (
		<Block>
			<Wizard>
				{/* STEP 1 */}
				<StepGender currentStep={1} totalSteps={8} />
				{/* STEP 2  */}
				{coupleCase ? (
					<StepCoupleGender currentStep={2} totalSteps={8} />
				) : (
					<StepAge currentStep={2} totalSteps={8} />
				)}
				{/* STEP 3 */}
				<StepLocation currentStep={3} totalSteps={8} />
				{/* STEP 4 */}
				<StepLogin currentStep={4} totalSteps={8} />
				{/* STEP 5 */}
				<StepPassword currentStep={5} totalSteps={8} />
				{/* STEP 6 */}
				<StepEmail currentStep={6} totalSteps={8} />
				{/* STEP 7 */}
				<StepThankYou currentStep={7} totalSteps={8} />
			</Wizard>
		</Block>
	);
};

// #####################################################

const mapStateToProps = ({
	auth: {
		register: {
			registerForm: {
				gender: { coupleCase },
			},
		},
	},
}) => ({
	coupleCase,
});

export default connect(mapStateToProps, {
	register,
})(Register);

// #####################################################
